/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_Choose_T3Inputs */

const en_site_choose_t3 = /** @type {(inputs: Site_Choose_T3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD & build`)
};

const id_site_choose_t3 = /** @type {(inputs: Site_Choose_T3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PRD & build`)
};

/**
* | output |
* | --- |
* | "PRD & build" |
*
* @param {Site_Choose_T3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const site_choose_t3 = /** @type {((inputs?: Site_Choose_T3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_Choose_T3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_site_choose_t3(inputs)
	return en_site_choose_t3(inputs)
});